import { render, staticRenderFns } from "./CertificateList.vue?vue&type=template&id=5719c0dc&scoped=true"
import script from "./CertificateList.vue?vue&type=script&lang=ts"
export * from "./CertificateList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5719c0dc",
  null
  
)

export default component.exports